module.exports = __webpack_public_path__ + "assets/views/intro/pad_triangle.png";